import { render, staticRenderFns } from "./SdgSectionHeader.vue?vue&type=template&id=08409992&scoped=true"
import script from "./SdgSectionHeader.vue?vue&type=script&lang=js"
export * from "./SdgSectionHeader.vue?vue&type=script&lang=js"
import style0 from "./SdgSectionHeader.vue?vue&type=style&index=0&id=08409992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08409992",
  null
  
)

export default component.exports